import React, { useEffect, useState } from 'react';
import { IWebViewScreenContent } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';

interface IWebViewScreenEditorProps extends IScreenEditorProps {
  content: IWebViewScreenContent;
}

const WebViewScreenEditor: React.FC<IWebViewScreenEditorProps> = ({
  content,
  errors,
  onContentChange,
  onFilesChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<IWebViewScreenContent>(content);

  useEffect(() => {
    setLocalContent(content);
  }, [content]);

  const updateContent = (updates: Partial<IWebViewScreenContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    
    // Validate on change
    const validationErrors = validate(newContent);
    onValidationChange(validationErrors);
  };

  const validate = (contentToValidate: IWebViewScreenContent = localContent): string[] => {
    const errors: string[] = [];
    if (!contentToValidate.url || !contentToValidate.url.trim()) {
      errors.push('URL is required');
    } else {
      try {
        new URL(contentToValidate.url);
      } catch {
        errors.push('Please enter a valid URL');
      }
    }
    return errors;
  };

  return (
    <div className="form-section">
      <h4>Web View Screen Content</h4>
      <p className="text-muted">
        Displays a website within the app using an embedded web view. The content will be shown directly inside the mobile app.
      </p>
      
      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">URL*</label>
          <div className="col-sm-9">
            <input 
              type="url" 
              className="form-control" 
              value={localContent.url} 
              onChange={(e) => updateContent({ url: e.target.value })} 
              placeholder="https://example.com" 
            />
            <span className="help-block">
              Enter the complete URL including https://
            </span>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Title</label>
          <div className="col-sm-9">
            <input 
              type="text" 
              className="form-control" 
              value={localContent.title || ''} 
              onChange={(e) => updateContent({ title: e.target.value })} 
              placeholder="Optional screen title" 
            />
            <span className="help-block">
              Optional title to display above the web view
            </span>
          </div>
        </div>

        {/* Hidden for now, may re-enable later
        <div className="form-group">
          <label className="col-sm-3 control-label">Navigation Controls</label>
          <div className="col-sm-9">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={localContent.showNavigationControls !== false}
                  onChange={(e) => updateContent({ showNavigationControls: e.target.checked })}
                />
                Show navigation controls (back, forward, reload)
              </label>
            </div>
            <span className="help-block">
              Allow users to navigate within the embedded web view
            </span>
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default WebViewScreenEditor;